<template>
  <p class="clearfix mb-0 text-center footer-text">
    <span class="d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25 font-weight-bold brand-link"
        href="https://aftercode.tn"
        target="_blank"
      >Aftercode</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
